<template>
  <vue-final-modal
    v-model="dialogVisible"
    name="workgate-popup-dialog"
    :classes="['workgate-dialog__container']"
    :content-class="['workgate-dialog__content', 'v--modal-box', 'v--modal']"
    :click-to-close="true"
    :esc-to-close="true"
    :lock-scroll="true"
    @closed="onWorkgateModalClosed"
  >
    <div
      class="v--modal-close-top"
      v-loading.fullscreen.lock="fullscreenLoading"
      v-if="nowStep == 2 && fromMypage == 'mypage'"
    >
      <el-button
        @click="closeDialog"
        icon="el-icon-circle-close"
        style="font-size: 2rem"
        type="text"
      ></el-button>
    </div>
    <div
      class="v--modal-close-top"
      v-loading.fullscreen.lock="fullscreenLoading"
      v-else-if="nowStep == 2"
    >
      <el-button
        @click="nowStep = 1"
        icon="el-icon-back"
        style="font-size: 2rem"
        type="text"
      ></el-button>
    </div>
    <div
      class="v--modal-close-top"
      v-loading.fullscreen.lock="fullscreenLoading"
      v-else
    >
      <el-button
        @click="closeDialog"
        icon="el-icon-circle-close"
        style="font-size: 2rem"
        type="text"
      ></el-button>
    </div>

    <!-- Step 1: 求人リスト -->
    <div id="renew2-popup-joblist-workgate" v-if="nowStep == 1">
      <div class="popup_block">
        <div class="txt_block">
          <!-- SP 端末保存フロー中は動的文言、通常は固定 -->
          <p v-if="spDownloadStatusLabel != null" class="txt01">
            {{ spDownloadStatusLabel }}
          </p>
          <p v-else class="txt01">ダウンロードが完了しました！！</p>
          <h3 class="txt02" style="font-size: 1.1rem">
            作成した履歴書で<br />好条件の勤め先に一緒に応募
          </h3>
          <p class="txt03">あなただけの限定求人</p>
        </div>
        <div style="font-size: 11px; padding-top: 10px">
          <p>
            <img
              src="/static/renew_img/check_icon.png"
              alt="同意する"
              style="height: 20px"
            />規約に同意して問い合わせる
          </p>
        </div>
        <!--求人リスト（Workgate + Carat 混在。規約注記は提供元ごとに一覧側が出す）-->
        <div class="popup_item">
          <recommend-job-list
            :blocks="blocks"
            variant="list"
            hide-applied
            @detail="onRecommendDetail"
            @apply="onRecommendApply"
          />
        </div>
      </div>
    </div>

    <!-- Step 2: 求人詳細 -->
    <recommend-job-detail-panel
      v-if="nowStep == 2"
      :detail="job_detail"
      @apply="onRecommendApply"
    />

    <!-- Step 3: 応募完了 -->
    <div id="renew2-popup-joblist-workgate" v-if="nowStep == 3">
      <div class="popup_block">
        <div class="txt_block" v-if="formatid != 'mypage'">
          <!-- SP 端末保存フロー中は動的文言、通常は固定 -->
          <p v-if="spDownloadStatusLabel != null" class="txt01">
            {{ spDownloadStatusLabel }}
          </p>
          <p v-else class="txt01">ダウンロードが完了しました！！</p>
        </div>

        <div class="popup_item">
          <div class="complete_block">
            <p class="complete_txt">
              お問い合わせありがとうございました。<br />担当者から追って連絡があります。
            </p>
          </div>
          <!--求人リスト（応募済みは出さない）-->
          <div class="popup_item" v-if="formatid != 'mypage'">
            <p class="complete_txt">他のお仕事もチェック！</p>
            <recommend-job-list
              :blocks="blocks"
              variant="list"
              hide-applied
              @detail="onRecommendDetail"
              @apply="onRecommendApply"
            />
          </div>
        </div>
      </div>
    </div>
  </vue-final-modal>
</template>

<style
  scoped
  lang="scss"
  src="@/assets/scss/components/workgate-dialog.scss"
></style>

<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
import { getCurrentInstance } from 'vue'
import { useEventListener } from '@vueuse/core'
import {
  emitter,
  WORKGATE_DIALOG_CLOSED,
  wrapMittPopupHandler
} from '@/plugins/emitter'
import { useWorkgateDialogEvents } from '@/composables/useWorkgateDialogEvents'

import {
  buildWorkgateApplyPayload,
  hasRequiredBasicInfo
} from '@/utils/workgate-apply-payload'
import {
  loadStoredResumeData,
  postDisplayDialogLog
} from '@/utils/workgate-dialog-io'
import RecommendJobDetailPanel from '@/components/recommend/RecommendJobDetailPanel.vue'
import RecommendJobList from '@/components/recommend/RecommendJobList.vue'
import { useRecommendJobs } from '@/composables/useRecommendJobs'
import { usePdfDownloadState } from '@/composables/usePdfDownloadState'
export default {
  components: {
    'recommend-job-list': RecommendJobList,
    'recommend-job-detail-panel': RecommendJobDetailPanel
  },
  setup() {
    const vm = getCurrentInstance().proxy
    // ブラウザ標準の popstate は VueUse 経由で直接listen（hub中継を経由しない）
    useEventListener(window, 'popstate', () => vm.closeDialog())

    useWorkgateDialogEvents(vm, wrapMittPopupHandler(vm, 'openDialog'))

    // 取得・応募・詳細組み立ては composable に集約（通信は JSON クライアント経由）。
    // 縦1列リストなので blockSize=1 で提供元が1件ずつ交互になる
    const recommend = useRecommendJobs('dialog')
    // Vue 2.7 の Options API + setup() では、setup() 内の computed() が
    // モジュールレベル ref の変化をテンプレート再描画につなげないケースがある。
    // ref を素のまま返し、Vue 2 の computed: オプションで this.xxx 経由で参照することで
    // Vue 2 の Observer ベースの依存追跡（確実）を使う。
    const { isPdfDownloading, isSpDownloadMode } = usePdfDownloadState()
    return {
      isPdfDownloading,
      isSpDownloadMode,
      recommendProviders: recommend.providers,
      blocks: recommend.blocks,
      totalCount: recommend.totalCount,
      recommendApplyingKey: recommend.applyingKey,
      recommendKeyword: recommend.keyword,
      loadRecommendJobs: recommend.load,
      applyCaratViaApi: recommend.applyCarat,
      applyWorkgateViaApi: recommend.applyWorkgate,
      buildRecommendDetail: recommend.buildDetail,
      markRecommendAppliedInStore: recommend.markApplied
    }
  },
  data: function () {
    return {
      nowStep: 1,
      job_detail: null,
      /** vue-final-modal の開閉状態 */
      dialogVisible: false,
      /** 詳細取得の世代番号。後着レスポンスの破棄に使う（onRecommendDetail 参照） */
      detailRequestSeq: 0,
      formatid: '',
      keyword: '',
      area: '',
      fullscreenLoading: false,
      fromMypage: '',
      // ユーザーデータ（localStorage から取得）
      storedBasicData: null,
      storedFormatData: null,
      storedResumeFormatData: null
    }
  },
  created: function () {},
  computed: {
    /**
     * SP 端末保存フロー中の動的タイトル（null = 通常フロー）。
     * this.isSpDownloadMode / this.isPdfDownloading は setup() から返した ref の
     * auto-unwrap 値。Vue 2 の computed: で参照することで Observer ベースの
     * 依存追跡が確実に機能する。
     */
    spDownloadStatusLabel: function () {
      if (!this.isSpDownloadMode) return null
      return this.isPdfDownloading
        ? 'ダウンロードの準備をしています。'
        : 'ダウンロードの準備ができました！'
    }
  },
  methods: {
    // --- メインエントリ ---
    openDialog: async function (
      formatId,
      previewFormat,
      basicData,
      keyword,
      area
    ) {
      // 不足があればポップアップを出さない（応募まで到達できないため）
      const fallbackEmail =
        (this.$firebase.user && this.$firebase.user.email) || ''
      if (!hasRequiredBasicInfo(basicData, fallbackEmail)) return

      this.dialogVisible = true
      this.formatid = formatId
      this.keyword = keyword || ''
      this.area = area || ''
      this.nowStep = 1
      this.recommendProviders = []
      this.recommendKeyword = ''
      this.job_detail = null
      // 前回開いていたときの詳細取得が飛んでいたら無効化する（後着で Step 2 へ飛ぶ）
      this.detailRequestSeq++
      this.fromMypage = formatId

      // localStorage からユーザーデータを取得
      const app = this
      const stored = await loadStoredResumeData(this.$iterateStorage, basicData)
      this.storedBasicData = stored.basic
      this.storedFormatData = stored.formatData
      this.storedResumeFormatData = stored.resume

      postDisplayDialogLog(this.$axios, this.$varuna.endPoints.displayDialog, {
        uuid: this.$firebase.user.uid,
        storage_data: JSON.stringify(stored.storageData),
        format_id: this.formatid,
        dialog_name: 'workgate_dialog',
        permission_type: 1,
        device_flg: this.$deviceLib.isMobileDevice ? 'SP' : 'PC',
        version: '2',
        site_flag: 'r',
        app_flag: this.$site.appFlag
      })

      // おすすめ求人リスト取得（Workgate + Carat 混在。フォーマットに応じた出し分け）
      this.fullscreenLoading = true
      try {
        await this.loadRecommendJobs({
          uuid: this.$firebase.user.uid,
          format_id: this.formatid,
          layout: 'dialog',
          address: (basicData && basicData.address1) || '',
          occupation: this.getOccupationByFormat(this.formatid),
          keyword: this.keyword || '',
          area: this.area || '',
          device_flg: this.$deviceLib.isMobileDevice ? 'SP' : 'PC',
          app_flag: this.$site.appFlag,
          site_flag: 'r'
        })
        app.dialogVisible = true
        if (this.totalCount > 0) {
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: 'あなたにピッタリの求人リストを取得しました',
            type: 'info'
          })
        }
      } finally {
        app.fullscreenLoading = false
      }
    },

    /**
     * providers から1件引く（正規化スキーマのまま返す）。
     * job_id は提供元ごとに別名前空間なので、provider が分かるときは併せて絞る。
     */
    /** 応募と詳細取得で同じ値を送る必要があるため1か所にまとめる */
    caratContext: function () {
      return {
        uuid: this.$firebase.user.uid,
        formatId: this.formatid || '',
        deviceFlag: this.$deviceLib.isMobileDevice ? 'SP' : 'PC',
        appFlag: this.$site.appFlag,
        siteFlag: 'r'
      }
    },

    /** 詳細画面で開いている求人を「応募済み」に切り替える（一覧側は composable が更新） */
    markDetailApplied: function (offer) {
      const detail = this.job_detail
      if (!detail || !offer) return
      const same =
        String(detail.job_id || detail.offer_id) ===
        String(offer.job_id || offer.offer_id)
      if (same) detail.is_applied = true
    },

    // --- 求人詳細表示 ---
    onRecommendDetail: async function (offer) {
      if (!offer) return
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message:
            '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      // 提供元ごとに詳細APIを叩く（縮退は composable 側で吸収）
      const seq = ++this.detailRequestSeq
      const detail = await this.buildRecommendDetail(offer, this.caratContext())
      // 待っている間に別の求人が選ばれていたら、古いレスポンスは捨てる
      if (seq !== this.detailRequestSeq) return
      if (!detail) {
        this.$message({ message: '求人詳細取得に失敗しました', type: 'error' })
        return
      }
      this.job_detail = detail
      this.nowStep = 2
    },

    // --- 応募 ---
    /**
     * @param {object} offer 正規化スキーマの求人
     * @param {'list'|'detail'} source 応募元。detail_flag（''/'d'）の既存規約に対応
     */
    onRecommendApply: function (offer, source) {
      if (!offer) return
      // 個人情報を伴う送信なので、提供元へ分岐する前に確認する
      if (!confirm('本当に応募しますか？')) return
      // 保留中の詳細取得を無効化する。応募完了(Step 3)後に後着すると
      // 完了画面が詳細で上書きされ、is_applied も取得時点の false に戻る
      this.detailRequestSeq++
      const from = source === 'detail' ? 'detail' : 'list'
      if (offer.provider === 'carat') {
        return this.applyCaratJob(offer, from)
      }
      return this.applyJob(offer, from)
    },
    applyCaratJob: async function (offer, source) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message:
            '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      try {
        const result = await this.applyCaratViaApi(
          offer,
          source,
          this.caratContext()
        )
        if (!result.ok) {
          // 応募済み判定なら再送しても必ず失敗する。詳細のボタンも閉じる
          if (result.alreadyApplied) this.markDetailApplied(offer)
          this.$message({ message: result.message, type: result.messageType })
          return
        }
        this.markDetailApplied(offer)
        this.nowStep = 3
      } finally {
        this.fullscreenLoading = false
      }
    },
    applyJob: async function (offer) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message:
            '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }

      const offerId = offer && (offer.job_id || offer.offer_id)
      if (!offerId) {
        this.$message({
          message: '応募対象の求人情報が不足しています',
          type: 'warning'
        })
        return
      }

      const payload = buildWorkgateApplyPayload({
        basic: this.storedBasicData,
        formatData: this.storedFormatData,
        resume: this.storedResumeFormatData,
        fallbackEmail: (this.$firebase.user && this.$firebase.user.email) || ''
      })
      if (payload.missingFields.length > 0) {
        this.$message({
          message:
            '応募に必要な情報が不足しています: ' +
            payload.missingFields.join('、'),
          type: 'warning'
        })
        return
      }

      this.fullscreenLoading = true
      try {
        const result = await this.applyWorkgateViaApi(offer, {
          uuid: this.$firebase.user.uid,
          offer_id: String(offerId),
          display_position: offer.displayPosition || 0,
          block_index: offer.blockIndex || 0,
          email: payload.email,
          lastname: payload.lastname,
          firstname: payload.firstname,
          lastname_kana: payload.lastname_kana,
          firstname_kana: payload.firstname_kana,
          birth: payload.birth,
          pref_code: payload.pref_code,
          address1: payload.address1,
          telephone: payload.telephone || undefined,
          zip_code: payload.zip_code || undefined,
          address2: payload.address2 || undefined,
          gender: payload.gender,
          education: payload.education || undefined,
          job_history: payload.job_history || undefined,
          current_job: payload.current_job || undefined,
          introduction: payload.introduction || undefined,
          environment: payload.environment,
          format_id: this.formatid || '',
          keyword: this.recommendKeyword || this.keyword || '',
          area: this.area || '',
          device_flg: this.$deviceLib.isMobileDevice ? 'SP' : 'PC',
          app_flag: this.$site.appFlag,
          site_flag: 'r'
        })
        if (!result.ok) {
          if (result.alreadyApplied) this.markDetailApplied(offer)
          this.$message({ message: result.message, type: result.messageType })
          return
        }
        this.markDetailApplied(offer)
        this.nowStep = 3
      } finally {
        this.fullscreenLoading = false
      }
    },

    closeDialog: function () {
      // 実際の emit は modal の @closed（onWorkgateModalClosed）に集約。
      // ×ボタン・オーバーレイ・ESC など全ての閉じ方で1回だけ発火させるため。
      this.dialogVisible = false
    },

    // ワークゲートが閉じた時（閉じ方を問わず）に発火。FormatEdit 側で YFプロモのトリガーに使う。
    onWorkgateModalClosed: function () {
      emitter.emit(WORKGATE_DIALOG_CLOSED)
    },

    // --- 表示ヘルパー（mixin: workgate-helpers-mixin から提供） ---
    getOccupationByFormat: function (formatId) {
      if (
        formatId === 'rerekisho_part_time' ||
        formatId === 'rirekisho_part_time2'
      ) {
        return 'アルバイト'
      }
      return '正社員'
    }
  }
}
</script>
